<script setup>
setPageTitle(PageMeta.Quotes.Preview.Title)
definePage({ meta: PageMeta.Quotes.Preview.Meta })

import QuotesServicePage from '@/views/Previews/Quotes/QuotesServicePage.vue'
import QuotesVerticalSidebar from '@/views/Previews/Quotes/QuotesVerticalSidebar.vue'

/* ****** */
</script>

<template>
  <section>
    <VRow>
      <VCol
        cols="12"
        md="9"
      >
        <!-- QuotePreview -->
        <QuotesServicePage />
      </VCol>

      <VCol
        cols="12"
        md="3"
      >
        <!-- Sidebar -->
        <QuotesVerticalSidebar />
      </VCol>
    </VRow>
  </section>
</template>

<style lang="scss">
.quote-preview-table {
  --v-table-row-height: 44px !important;
}

@media print {
  .v-application {
    background: none !important;
  }

  @page {
    margin: 0;
    size: auto;
  }

  .layout-page-content,
  .v-row,
  .v-col-md-9 {
    padding: 0;
    margin: 0;
  }

  .product-buy-now {
    display: none;
  }

  .v-navigation-drawer,
  .layout-vertical-nav,
  .app-customizer-toggler,
  .layout-footer,
  .layout-navbar,
  .layout-navbar-and-nav-container {
    display: none;
  }

  .v-card {
    box-shadow: none !important;

    .print-row {
      flex-direction: row !important;
    }
  }

  .layout-content-wrapper {
    padding-inline-start: 0 !important;
  }
}
</style>
